import NotFound from '../components/NotFound'
import SubscriptionGate from '../components/Subscriptions/SubscriptionGate'
import PublicDocs from '../docs/components/PublicDocs'
import { docRoutes } from '../docs/routes/_config'
import PrivacyPolicy from '../legal/PrivacyPolicy'
import SubscriptionAgreementDocument from '../legal/SubscriptionAgreementDocument'
import TermsOfUse from '../legal/TermsOfUse'
import BillingPage from '../pages/admin/siteConfiguration/Billing/BillingPage'
import DemoTutorialCalendly from '../pages/dev/DemoTutorialCalendly'
import StartTeamsMeeting from '../pages/dev/StartTeamsMeeting'
import Support from '../pages/dev/Support'
import UpdatesHub from '../pages/dev/Updates'
import WebsiteQueries from '../pages/system/WebsiteQueries/WebsiteQueries'
import GettingStarted from '../pages/userPages/gettingStarted/GettingStarted'
import MainDashboard from '../pages/userPages/dashboard/MainDashboard'
import RootRedirect from '../navigation/RootRedirect'
import MyResource from '../pages/userPages/myResource/MyResource'
import ManagerOverview from '../pages/userPages/dashboard/managerOverview/ManagerOverview'
import GoogleAuthCallback from '../services/GoogleAuthCallback'

export default [
  { path: '*', element: <NotFound /> },
  {
    path: '/',
    element: (
      <RootRedirect>
        <MainDashboard />
      </RootRedirect>
    ),
  },
  {
    path: '/getting-started',
    element: <GettingStarted />,
    title: 'Getting Started',
  },
  {
    path: '/dashboard',
    element: <ManagerOverview />,
    title: 'Global Overview',
  },
  {
    path: '/my-resource',
    element: <MyResource />,
    title: 'My Resource',
  },
  { path: '/support', element: <Support />, title: 'Support' },
  {
    path: '/support/one-to-one/teams/lukejones/b2820f2f-2861-40b8-95b6-66fd2ac4bcf3',
    element: <StartTeamsMeeting />,
  },
  {
    path: '/support/demo-tutorial',
    element: <DemoTutorialCalendly />,
    title: 'Demo Tutorial'
  },
  { path: '/updates', element: <UpdatesHub />, title: 'AmbuNet Updates' },
  { path: '/docs/updates', element: <UpdatesHub />, title: 'Updates' },
  {
    path: '/docs/*',
    element: <PublicDocs />,
    title: 'Knowledgebase',
    children: docRoutes,
  },
  { path: '/website-enquiries', element: <WebsiteQueries /> },
  { path: '/settings/googleauthcallback', element: <GoogleAuthCallback /> },

  { path: '/billing', element: <BillingPage />, title: 'Billing' },
  // The AmbuNet Business Subscription Agreement, readable while signed in:
  // the current version, or the one named (the version an organisation
  // accepted stays readable after a newer one is published).
  {
    path: '/subscription-agreement',
    element: <SubscriptionAgreementDocument />,
    title: 'Business Subscription Agreement',
  },
  {
    path: '/subscription-agreement/:version',
    element: <SubscriptionAgreementDocument />,
    title: 'Business Subscription Agreement',
  },
  // Also in PublicRouter: the public pages that link to these (patient and
  // event feedback, witness statements) must work for signed-in staff too.
  { path: '/privacy-policy', element: <PrivacyPolicy />, title: 'Privacy Policy' },
  { path: '/terms-of-use', element: <TermsOfUse />, title: 'Terms of Use' },
]
